import { ToastVariants } from '@features/ui-atoms/components/Toast';
import { create } from 'zustand';

interface Toast {
  o: boolean;
  message: string;
  title?: string;
  variant?: ToastVariants;
}

interface ToastStore {
  openToast: Toast;
  setOpenToast: (toast: Toast) => void;
  resetToast: () => void;
}

export const useToastStore = create<ToastStore>(set => ({
  openToast: { o: false, message: '' },
  setOpenToast: (toast: Toast) => set({ openToast: toast }),
  resetToast: () => set({ openToast: { o: false, message: '' } }),
}));
